import {AsyncComponent} from '@modifi/code-splitting'
import {FullScreenLoader} from '@modifi/ui'

export const WelcomePage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "intro" */ './welcome-new'),
  loader: FullScreenLoader,
})

export const ProgressLayout = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "intro" */ './progress-layout'),
  loader: FullScreenLoader,
})
